// Country-aware wording for the geography tiers. Canadian province and
// territory abbreviations never collide with US state codes, so the
// abbreviation alone identifies the country.
export const CANADIAN_REGIONS = new Set(['AB', 'BC', 'MB', 'NB', 'NL', 'NS', 'NT', 'NU', 'ON', 'PE', 'QC', 'SK', 'YT']);

export const countryOfRegion = (abbr) => (CANADIAN_REGIONS.has(String(abbr ?? '').toUpperCase()) ? 'CA' : 'US');

const TERMS = {
  US: { country: 'US', region: 'State', county: 'County', counties: 'Counties', point: 'ZIP', points: 'ZIP codes' },
  CA: {
    country: 'CA',
    region: 'Province / territory',
    county: 'Census division',
    counties: 'Census divisions',
    point: 'Municipality',
    points: 'municipalities',
  },
};

export const regionTerms = (abbr) => TERMS[countryOfRegion(abbr)];
